// (?=.*\d). 判断是否至少有1个数字
const APP_DETAIL_ENDPOINT = /api\/community\/v1\/publications\/(?=.*\d).+[\w\d]+$/;

const IMAGE_DETAIL_ENDPOINT = /api\/resources\/v1\/images\/(?=.*\d).+[\w\d]+$/;

export const DETAIL_ENDPOINTS = {
	APP: APP_DETAIL_ENDPOINT,
	IMAGE: IMAGE_DETAIL_ENDPOINT,
};
